import { render, staticRenderFns } from "./NgoSearchCard.vue?vue&type=template&id=c96bb140&"
import script from "./NgoSearchCard.vue?vue&type=script&lang=js&"
export * from "./NgoSearchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports